module.exports = __webpack_public_path__ + "img/img34.c015c5f8.svg";